import type { ComponentPropsWithRef, ReactNode } from "react";
import Markdown from "react-markdown";

interface MarkdownContainerProps extends ComponentPropsWithRef<"div"> {
	children: string;
}

/**
 * Container that sets the prose styling for markdown content.
 */
export const MarkdownContainer = ({
	children,
	className,
	ref,
	...props
}: MarkdownContainerProps): ReactNode => {
	return (
		<Markdown className={className} {...props}>
			{children}
		</Markdown>
	);
};

MarkdownContainer.displayName = "MarkdownContainer";
